(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["online-showroom-paths"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.MODOpenMattressesMenuBound) return;
  window.MODOpenMattressesMenuBound = true;

  var selectors = {
    button: '[data-open-mattresses-menu]',
    menuItem: '.site-header-link-left li[data-menu-title="Mattresses"].has-megamenu',
    nav: '.site-header-link',
    hamburger: '.ham-btn'
  };

  function getMattressesMenuItem() {
    return document.querySelector(selectors.menuItem);
  }

  function setButtonExpanded(isExpanded) {
    document.querySelectorAll(selectors.button).forEach(function (button) {
      button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    });
  }

  function setMenuExpanded(menuItem, isExpanded) {
    if (!menuItem) return;
    menuItem.classList.toggle('is-open', !!isExpanded);

    var menuLink = menuItem.querySelector(':scope > a');
    if (menuLink) {
      menuLink.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }

    setButtonExpanded(isExpanded);
  }

  function openMattressesMenu() {
    var menuItem = getMattressesMenuItem();
    if (!menuItem) {
      window.location.href = '/collections/mattresses';
      return;
    }

    var nav = document.querySelector(selectors.nav);
    var hamburger = document.querySelector(selectors.hamburger);

    if (window.innerWidth < 992) {
      if (nav && !nav.classList.contains('open')) {
        if (hamburger) {
          hamburger.click();
        } else {
          nav.classList.add('open');
        }
      }

      if (hamburger) hamburger.classList.add('active');
      Array.prototype.forEach.call(menuItem.parentElement ? menuItem.parentElement.children : [], function (sibling) {
        if (sibling !== menuItem && sibling.classList && sibling.classList.contains('has-megamenu')) {
          setMenuExpanded(sibling, false);
        }
      });
      setMenuExpanded(menuItem, true);
      if (nav) nav.scrollTop = 0;
      menuItem.scrollIntoView({ block: 'start', behavior: 'smooth' });
      return;
    }

    document.querySelectorAll('.site-header-link-left .has-megamenu.is-open').forEach(function (openItem) {
      if (openItem !== menuItem) setMenuExpanded(openItem, false);
    });
    setMenuExpanded(menuItem, true);

    var menuLink = menuItem.querySelector(':scope > a');
    if (menuLink) menuLink.focus({ preventScroll: true });
  }

  function closeMattressesMenu() {
    setMenuExpanded(getMattressesMenuItem(), false);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(selectors.button);
    if (button) {
      event.preventDefault();
      openMattressesMenu();
      return;
    }

    var menuItem = getMattressesMenuItem();
    if (!menuItem || !menuItem.classList.contains('is-open')) return;
    if (event.target.closest(selectors.menuItem)) return;

    closeMattressesMenu();
  });

  document.addEventListener('mouseover', function (event) {
    if (window.innerWidth < 992) return;
    var hoveredMenu = event.target.closest('.site-header-link-left .has-megamenu');
    var menuItem = getMattressesMenuItem();
    if (hoveredMenu && menuItem && hoveredMenu !== menuItem) {
      closeMattressesMenu();
    }
  });

  document.addEventListener('keydown', function (event) {
    var button = event.target.closest && event.target.closest(selectors.button);
    if (button && event.key === ' ') {
      event.preventDefault();
      openMattressesMenu();
      return;
    }

    if (event.key === 'Escape') {
      closeMattressesMenu();
    }
  });
}());

  } catch(e) { console.error(e); }
})();
})();
